import { Component, OnInit } from '@angular/core';

import { Certificate } from '@app/models/certifications.model';
import { CertificationService } from '@app/services/docebo/certification.service';
import { SessionStorageKeys } from '@app/enums/session-storage-keys.enum';
import { User } from '@app/models/_index';
import { UserService } from '@app/services/user/user.service';
import { environment } from '@environments/environment';
import { firstValueFrom } from 'rxjs';
import { getAdditionalFieldValue } from '@app/utilities/_index';

@Component({
  selector: 'app-dashboard-certifications',
  templateUrl: './dashboard-certifications.component.html',
  styleUrls: ['./dashboard-certifications.component.scss'],
  standalone: false,
})
export class DashboardCertificationsComponent implements OnInit {
  certificates: Certificate[] = [];
  isLoading: boolean;

  currentUser: User; // Signed In User
  sfdcID: string; // SalesForce Docebo User ID

  constructor(private userService: UserService, private certificateService: CertificationService) {}

  /**
   * OnInit loads the user and loads certificate from the shared user service
   * Load validate (non-expiring) certificates for the current logged in user, if available.
   */
  async ngOnInit(): Promise<void> {
    this.currentUser = await firstValueFrom(this.userService?.doceboUser$);

    // Load valid and completed and non-expired certificates
    this.loadValidCertificates();
  }

  /**
   * Loads Valid Non-Expired Certificate Badges for a user if exists.
   * The n-#-mod is a css grid styling to handle badges by grids of 4 badges per line,
   * 3 badges per line, or 2 badges per line
   */
  loadValidCertificates(): void {
    this.isLoading = true;
    const email = this.currentUser?.email;

    localStorage.removeItem(SessionStorageKeys.CERTIFICATES);

    this.certificateService
      .getCertificates(email)
      .then((certificate: Certificate[]) => {
        this.certificates = certificate;
        // Load Certificates in cache
        localStorage.setItem(SessionStorageKeys.CERTIFICATES, JSON.stringify(this.certificates));
        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
        console.error('Unable to load certifications', err);
      });
  }

  /**
   * Add Track By Certification title to not redraw or re-render list items that have not changed.
   * This improves performance.
   * @param index - Index of Certification Array
   * @param item -  item
   * @returns title of certification
   */
  trackByCertificationTitle(index: number, item: Certificate): string {
    if (item) {
      return item.title;
    } else {
      return String(index);
    }
  }
}
